import {
  api,
  apiStore,
  authStore,
  subscribeToUserChannel,
  unsubscribeFromUserChannel,
} from "../services";

authStore.subscribe(
  (state) => state.token,
  (token) => {
    if (token) {
      api.setBearer(token);

      // Retry /user (was 401)
      apiStore.invalidateQuery("user");
    } else {
      api.setBearer(null);

      // Log out
      apiStore.resetQueries();
    }
  }
);

let subscribedUserId: number | null = null;

authStore.subscribe(
  (state) => state.userId,
  (userId) => {
    if (userId) {
      subscribeToUserChannel(userId, {
        onBooking: () => {
          apiStore.invalidateQuery("bookings");
        },
        onChatMessage: () => {
          apiStore.invalidateQuery("chats");
          apiStore.invalidateQuery("chat");
        },
      });
      subscribedUserId = userId;
    } else if (subscribedUserId) {
      unsubscribeFromUserChannel(subscribedUserId);
      subscribedUserId = null;
    }
  }
);
